import { TestSessionStatus, TestSessionSummaryDTO } from '@/api/generated';
import palette from '@/theme/palette';

export const getTestSessionIconStyles = (enabled: boolean = true) => ({
  '& svg': {
    display: 'block'
  },

  '& .buffer': {
    fill: enabled ? palette.primary[250] : palette.grey[200]
  },

  '& .stroke': {
    stroke: enabled ? palette.primary.main : palette.grey[500]
  }
});

export function isRetest(testSession: TestSessionSummaryDTO): boolean {
  return isComplete(testSession) && Boolean(testSession.retest);
}

export function isRefused(testSession: TestSessionSummaryDTO): boolean {
  return testSession.status === TestSessionStatus.REFUSED;
}

export function isComplete(testSession: TestSessionSummaryDTO): boolean {
  return testSession.status === TestSessionStatus.COMPLETED;
}

export function isInProgress(testSession: TestSessionSummaryDTO): boolean {
  return testSession.status === TestSessionStatus.IN_PROGRESS;
}

function isFinal(testSession: TestSessionSummaryDTO): boolean {
  return isComplete(testSession) || isRefused(testSession);
}

export function isTalentFinished(processTestSessions: TestSessionSummaryDTO[] | undefined): boolean {
  if (!processTestSessions) return false;

  return processTestSessions.length > 0 && processTestSessions.every(isFinal);
}
